/* eslint-disable */
import { req } from 'react-reqq-lite';
import { toastSuccess } from 'react-geek-toast';

import * as c from './contants';
import { transformApiKeyList } from './transformers';

export const getApiKeyList = (id, params) => {
  req.get({
    key: c.MERCHANT_API_KEY_LIST,
    url: `/merchant_api_key/v1/my/merchants/${id}/api_keys`,
    transform: ({ data }) => (data || []).map(transformApiKeyList),
  });
};

export const apiKeyActiveInactive = (
  merchantId,
  apiKeyId,
  status,
  onSuccess
) => {
  req.put({
    key: c.MERCHANT_API_KEY,
    url: `/merchant_api_key/v1/my/merchants/${merchantId}/api_keys/${apiKeyId}/enable_disable`,
    payload: {
      status: status?.toUpperCase(),
    },
    onSuccess: ({ response }, state) => {
      setTimeout(() => {
        getApiKeyList(response?.data?.merchant_uuid, state[c.MERCHANT_FILTER]);
      }, 1000);
      toastSuccess(`API Token is ${status}!`);
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};

export const regenerateApiKey = (merchantId, apiKeyId, onSuccess) => {
  req.put({
    key: c.MERCHANT_API_KEY_REGENERATE,
    url: `/merchant_api_key/v1/my/merchants/${merchantId}/api_keys/${apiKeyId}/refresh_token`,
    onSuccess: ({ response }, state) => {
      toastSuccess(`API Key successfully regenerated!`);
      setTimeout(() => {
        getApiKeyList(response?.data?.merchant_uuid, state[c.MERCHANT_FILTER]);
      }, 1000);
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};

export const updateApiKey = (merchantId, apiKeyId, payload, onSuccess) => {
  req.put({
    key: c.MERCHANT_API_KEY_ITEM,
    payload,
    url: `/merchant_api_key/v1/my/merchants/${merchantId}/api_keys/${apiKeyId}`,
    onSuccess: ({ response }, state) => {
      setTimeout(() => {
        getApiKeyList(response?.data?.merchant_uuid, state[c.MERCHANT_FILTER]);
      }, 1000);
      toastSuccess('Updated!');
      if (typeof onSuccess === 'function') onSuccess();
    },
  });
};
